import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { tenantAtom } from "../../../atoms/GlobalAtoms";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import API from "../../api/API";

const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const [tenant] = useAtom(tenantAtom);

  const updateUser = useMutation({
    mutationFn: ({
      userID,
      payload,
      onSuccess,
    }: {
      userID: string;
      payload: any;
      onSuccess: () => void;
    }) =>
      API.updateUser(userID, payload).then((data) => {
        const updatedUser = data.data.data;
        queryClient.setQueryData(["user", tenant?.TenantID], (prev: any) => ({
          ...(prev || {}),
          user: updatedUser,
        }));

        callFunctionIfExists(onSuccess);
      }),
  });

  return {
    updateUser: updateUser.mutate,
    userUpdating: updateUser.isPending,
    updateUserError: updateUser.error
      ? getErrorMessage(updateUser.error)
      : null,
  };
};

export default useUpdateUser;
